<template>
  <div class="container my-5">
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück
    </button>
    <h2 class="text-center mb-4">Auszahlungen Übersicht</h2>

    <div class="filters mb-4">
      <div class="row">
        <div class="col-md-4">
          <input v-model="searchQuery" type="text" class="form-control"
            placeholder="Suche Kunde, Kundennummer oder Artikel" />
        </div>
        <div class="col-md-3">
          <input v-model="dateFrom" type="date" class="form-control" />
        </div>
        <div class="col-md-3">
          <input v-model="dateTo" type="date" class="form-control" />
        </div>
        <div class="col-md-2">
          <button @click="fetchPayouts" class="btn btn-primary w-100">Filtern</button>
        </div>
      </div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden...</span>
      </div>
    </div>
    <table v-else-if="payouts.length" class="table table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Kunde</th>
          <th>Kundennummer</th>
          <th>Artikelanzahl</th>
          <th>Betrag (CHF)</th>
          <th>Datum</th>
          <th>Aktion</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in payouts" :key="p.id">
          <td>{{ p.id }}</td>
          <td>{{ p.Customer.FirstName }} {{ p.Customer.LastName }}</td>
          <td>{{ p.CustomerId }}</td>
          <td>{{ p.Articles.length }}</td>
          <td>{{ $formatPrice(p.TotalAmount) }}</td>
          <td>{{ formatDate(p.PayoutDate) }}</td>
          <td>
            <button @click="goToDownload(p.id)" class="btn btn-outline-primary btn-sm">
              <font-awesome-icon icon="download" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <p>Keine Auszahlungen gefunden.</p>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  name: 'PayoutsOverview',
  data() {
    const today = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 2);
    return {
      searchQuery: '',
      dateFrom: twoMonthsAgo.toISOString().substr(0, 10),
      dateTo: today.toISOString().substr(0, 10),
      payouts: [],
      errorMessage: '',
      loading: false
    };
  },
  methods: {
    goBack() {
      this.$router.push('/admin/auszahlung');
    },
    async fetchPayouts() {
      this.errorMessage = '';
      this.loading = true;
      try {
        const params = {};
        if (this.searchQuery) params.search = this.searchQuery;
        if (this.dateFrom) params.dateFrom = this.dateFrom;
        if (this.dateTo) params.dateTo = this.dateTo;
        const res = await axios.get('/payouts', { params });
        this.payouts = res.data;
      } catch (err) {
        console.error(err);
        this.errorMessage = 'Fehler beim Laden der Auszahlungen.';
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const dd = ('0' + d.getDate()).slice(-2);
      const mm = ('0' + (d.getMonth() + 1)).slice(-2);
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },
    goToDownload(id) {
      this.$router.push(`/admin/payouts/${id}/download`);
    },
  },
  mounted() {
    this.fetchPayouts();
  },
};
</script>


<style scoped>
.filters .row>div {
  margin-bottom: 10px;
}
</style>